
document.addEventListener(
  'toggle',
  function (event) {
    const openedDetails = event.target;

    // Only run for opened <details> elements
    if (!(openedDetails instanceof HTMLDetailsElement) || !openedDetails.open) return;

    // Only target Horizon accordion rows
    if (!openedDetails.matches('accordion-custom > details')) return;

    const accordion = openedDetails.closest('.accordion');
    if (!accordion) return;

    accordion.querySelectorAll('accordion-custom > details[open]').forEach(function (details) {
      if (details === openedDetails) return;
      if (details.closest('.accordion') !== accordion) return;

      details.removeAttribute('open');
    });
  },
  true
);